export default (key) => {
  const value = document.cookie.match(`(^|;)\\s*${key}\\s*=\\s*([^;]+)`);
  return value ? value.pop() : null;
};
